import { Button } from 'components/ui';
import { StepperContext, withStepperContext } from 'components/ui/stepper';
import PropType from 'prop-types';
import React from 'react';

export class PreviousStep extends React.Component {
  static propTypes = {
    prevStep: PropType.func.isRequired,
    stepState: PropType.oneOfType([PropType.func, PropType.object]).isRequired
  };

  goBack = () => {
    const { prevStep, stepState } = this.props;

    if (stepState instanceof Function) prevStep({});
    else prevStep(stepState);
  };

  render() {
    const {
      prevStep,
      nextStep,
      stepState,
      activeStep: _activeStep,
      prevSteps: _prevSteps,
      ...props
    } = this.props;

    return (
      <StepperContext.Consumer>
        {({ prevSteps, activeStep }) => {
          if (!prevSteps[activeStep]) return null;
          return (
            <Button
              onClick={this.goBack}
              {...props}
              data-testid="previous-step-button"
            >
              Back
            </Button>
          );
        }}
      </StepperContext.Consumer>
    );
  }
}

export default withStepperContext(PreviousStep);
